module.exports = __webpack_public_path__ + "static/media/twitter-dark.2196f4ce.svg";